import type { App } from "vue";
import { ElLoading } from "element-plus";

export default {
  install(app: App) {
    app.directive("loading", ElLoading.directive);
  },
};
